import { PasswordStrength } from '@/pages/CreatePassword/components/PasswordStrengthBar'
import { mediumPasswordRegExp, strongPasswordRegExp } from '../regExp'
import { CheckPasswordSecurityReturn } from './types'

export const passwordStrengthMessage = {
  weak: 'Senha fraca, utilize nossas dicas de senha',
  medium: 'Sua senha pode melhorar, utilize nossas dicas de senha',
  strong: 'Sua senha está ótima!',
  default: '',
}

export const checkPasswordStrength = (password: string): PasswordStrength => {
  if (strongPasswordRegExp.test(password)) {
    return 'strong'
  }

  if (mediumPasswordRegExp.test(password)) {
    return 'medium'
  }

  return 'weak'
}

export const checkPasswordSecurity = (
  password: string,
): CheckPasswordSecurityReturn => {
  const hasAtLeastEightChars = /.{8,}/.test(password)
  const hasAtLeastOneSpecialChar = /(?=.*[!@#$%^&+=*_]).*$/.test(password)
  const hasAtLeastOneNumber = /^.*\d+.*$/.test(password)
  const hasUpperAndLowerCaseChars = /^(?=.*[A-Z])(?=.*[a-z]).*$/.test(password)

  return {
    hasAtLeastEightChars,
    hasAtLeastOneSpecialChar,
    hasAtLeastOneNumber,
    hasUpperAndLowerCaseChars,
  }
}
